"use strict";

import angular from "angular";

const name = "lazyLoad";
const factory = [
    "$document",
    "$timeout",
    function ($document, $timeout) {
        return {
            restrict: "A",
            scope: {
                loadMore: "=",
                offset: "=",
                timing: "=",
                triggerLoad: "="
            },
            link: function ($scope, $element, $attr) {
                $scope.$watch("triggerLoad", (newValue, oldValue) => {
                    if (newValue)
                        $timeout(() => {
                            _loadMore();
                        }, 500);
                });
                $element.bind("scroll", () => {
                    if (
                        $element[0].scrollHeight <=
                        $element[0].offsetHeight + $element[0].scrollTop
                    ) {
                        setTimeout(() => {
                            if ($scope.loadMore) $scope.loadMore();
                            if (!$scope.$$phase) $scope.$apply();
                        }, 1000);
                    }
                });
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
